import React from "react";

const LazyLine = React.lazy(() =>
  import('react-chartjs-2').then(mod => ({ default: mod.Line }))
);
export default LazyLine;
